'use strict';

angular.module('shiftTraderApp')
  .factory('Notifications', function (ServerUrls, $http, $injector, Session, $q) {

    //Notification model constructor
    var Notification = function(values) {
      var N = {};

      angular.extend(N, values);
      N.shortType = values.type.slice(14); // Remove Notification:: class prefix from Rails STI
      N._created_at = moment.utc(values.created_at).tz(Session.getTimezone());

      if (_.has(values, 'shift_trade') && values['shift_trade']) {
        var ShiftTradeResource = $injector.get('ShiftTradesResource');
        N.shift_trade = new ShiftTradeResource(values.shift_trade);
        N.shift_trade = N.shift_trade.$initialize();
      }

      if (_.has(values, 'user') && values['user']) {
        var Users = $injector.get('Users');
        N.user = Users.initWithData(values.user);
      }

      if(_.has(values, 'availability_rule') && values['availability_rule']) {
        var AvailabilityRules = $injector.get('AvailabilityRules');
        N.availability_rule = AvailabilityRules.initWithData(values.availability_rule);
      }

      if(_.has(values, 'user_availability_change_request') && values['user_availability_change_request']) {
        var UACR = $injector.get('UserAvailabilityChangeRequests');
        N.user_availability_change_request = UACR.initWithData(values.user_availability_change_request);
      }

      if(_.has(values, 'availability_set') && values['availability_set']) {
        var AvailabilitySets = $injector.get('AvailabilitySets');
        N.availability_set = AvailabilitySets.initWithData(values.availability_set);
      }

      if(_.has(values, 'cancelled_work_period') && values['cancelled_work_period']) {
        var WorkPeriods = $injector.get('WorkPeriods');
        N.cancelled_work_period = WorkPeriods.initWithData(values.cancelled_work_period);
      }

      N.$isActionable = function() {
        return true;
      };
      N.show = !values.viewed;

      N.$setViewed = function() {
        var that = this;
        return $http.put(ServerUrls.current.railsApi + 'notifications/' + this.id, {
          viewed: true
        })
          .then(function() {
            that.viewed = true;
            return that;
          }, function(response) {
            return $q.reject(response);
          });
      };
      return N;
    };

    var Notifications = {};

    Notifications.getNewNotifications = function () {
        return $http.get(ServerUrls.current.railsApi + 'notifications')
          .then(function (response) {
            return _.map(response.data, function (notification) {
              return new Notification(notification);
            });
          }, function(response) {
            console.log('notifications fetch failed with status' + response);
            return $q.reject(response);
          });
      };

    Notifications.getReadNotifications = function () {
      return $http.get(ServerUrls.current.railsApi + 'notifications',
        {
          params: { viewed: true }
        })
        .then(function (response) {
          return _.map(response.data, function(notification) {
            return new Notification(notification);
          });
        }, function(response) {
          console.log('notifications fetch failed with status' + response);
          return $q.reject(response);
        });
    };

    return Notifications;
  });
